import reducer from './advisorApplicationsReducer';
import actions from './advisorApplicationsActions';
import createProvider from '../../utilities/createProvider';

export default createProvider(actions, reducer);
